'use client';

import clsx from 'clsx';
import Button, { ButtonType } from '@/components/Button/Button';
import styles from './Card.module.scss';
import Text from '@/components/Text/Text';
import { normalizeHtmlStyles } from '@/normalizeHtmlStyles';

export interface ICard {
  id: number;
  title: string;
  reference: string;
  link: string;
}

const Card = ({ card }: { card: ICard }) => (
  <section
    key={card.id}
    className={styles.card}
  >
    <div className={styles.cardText}>
      {card.title && (
        <Text tag='h4'>{card.title}</Text>
      )}
      <div
        className={clsx(styles.description, 'htmlEditorContent')}
        dangerouslySetInnerHTML={{
          __html: normalizeHtmlStyles(card.reference),
        }}
      />
    </div>
    {card.link && (
      <Button
        className={styles.readMore}
        type={ButtonType.TEXT_LIGHT}
        iconName='arrow_forward'
        iconPosition='right'
        iconSize={20}
        href={card.link}
      >
        Read more
      </Button>
    )}
  </section>
);

export default Card;
